import React from "react";
import { GetServerSideProps } from "next";

import { MissionPage } from "@vrw-guppy/react-vrw";
import OgpHead from "@/components/OgpHead";
import { MissionReadResponse } from "@/lib/models/mission";
import { getItem } from "@/lib/apiClient";

type GetItemProps = {
  item: MissionReadResponse;
  pk: string;
};

export const getServerSideProps: GetServerSideProps<GetItemProps> = async (
  context
) => {
  let { type, pk } = context.query as { pk: string; type: string };
  try {
    const item = await getItem({
      type: type as string,
      pk: pk as string,
    });

    return {
      props: {
        item,
        pk,
      },
    };
  } catch (e: any) {
    if (String(e).includes("404")) {
      return {
        notFound: true,
      };
    } else {
      throw e;
    }
  }
};

const App = ({ item }: GetItemProps) => {
  return (
    <>
      <OgpHead
        title={"ミッション情報 : " + item.name}
        thumbnailUrl={item.image_url}
      />
      <MissionPage item={item} />
    </>
  );
};

export default App;
